import { useStateStore } from '../../stores/useStateStore';

export const useSetCurrentUser = () =>
  useStateStore((state) => state.setCurrentUser);
